module.exports = __webpack_public_path__ + "static/img/david-kaloczi-uiOsg4AYHsw-unsplash_thumb.3d016f2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/david-kaloczi-uiOsg4AYHsw-unsplash_thumb.png
// module id = USQ3
// module chunks = 4